<template>
  <div>
    <div slot="table-busy" class="text-center small text-dark my-5 pt-5" v-if="isBusy === true">
      <b-spinner class="align-middle mx-2"></b-spinner>
      <strong>Loading...</strong>
    </div>

    <div class='demo-app' aria-busy="false" v-if="isBusy === false">
      <div class='demo-app-top'>
        <button @click="toggleWeekends" class="mb-2">Toggle weekends</button>
        <!-- <button @click="gotoPast">go to a date in the past</button> -->
        Click on a day to add event
      </div>
      <FullCalendar
              class='demo-app-calendar'
              ref="fullCalendar"
              defaultView="dayGridMonth"
              :header="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      }"
              :plugins="calendarPlugins"
              :weekends="calendarWeekends"
              :events="calendarEvents"
              @dateClick="handleDateClick"
      />
    </div>
  </div>
</template>

<script>
  import { db } from '../main';
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import timeGridPlugin from '@fullcalendar/timegrid'
  import interactionPlugin from '@fullcalendar/interaction'
  export default {
    components: {
      FullCalendar // make the <FullCalendar> tag available
    },
    data: function() {
      return {
        isBusy: true,
        customers: [],
        calendarPlugins: [ // plugins must be defined in the JS
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        calendarWeekends: true,
        calendarEvents: [ // initial event data
          { title: 'Event Now', start: new Date() }
        ]
      }
    },
    beforeMount(){
      this.getForsynList();
    },
    methods: {
      toggleWeekends() {
        this.calendarWeekends = !this.calendarWeekends // update a property
      },
      gotoPast() {
        let calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
        calendarApi.gotoDate('2019-08-01') // call a method on the Calendar object
      },
      handleDateClick(arg) {
        if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
          this.calendarEvents.push({ // add new event data
            title: 'New Event',
            start: arg.date,
            allDay: arg.allDay
          })
        }
      },

      async getForsynList () {
        await db.collection('customers').get().then(resp => {
          let forsynListCollection = [];
          resp.forEach(doc => {
            const forsynListData = doc.data();
            if(forsynListData.dateForsyn !== null && forsynListData.dateForsyn !== '' && forsynListData.dateForsyn !== undefined ) {
              forsynListCollection.push({
                backgroundColor: 'lightblue',
                title: 'FÖRSYN: \r\n' + forsynListData.adress,
                start: forsynListData.dateForsyn
              });
            }
            if(forsynListData.dateDigging !== null && forsynListData.dateDigging !== '' && forsynListData.dateDigging !== undefined ) {
              forsynListCollection.push({
                backgroundColor: 'lightgreen',
                title: 'GRÄVNING: \r\n' + forsynListData.adress,
                start: forsynListData.dateDigging
              });
            }
          });
          this.calendarEvents = forsynListCollection;
          console.log(this.customers);
          this.isBusy = false;
        } );
      },
    }
  }
</script>

<style lang='scss'>
  // you must include each plugins' css
  // paths prefixed with ~ signify node_modules
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';
  @import '~@fullcalendar/timegrid/main.css';
  .demo-app {
    font-family: -apple-system,
    BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji";
    font-size: 14px;
    color: #333;
  }
  .demo-app-top {
    margin: 0 0 2em;
  }
  .demo-app-calendar {
    margin: 0 auto;
    max-width: 900px;
  }

  button {
    border-radius: 2px;
    color: #333;
    border: 2px solid #eee;
  }

  .fc-scroller, .fc-day-grid-container {
    overflow: visible !important;
  }
  .fc-unthemed td.fc-today {
    background-color: #eee;
    font-weight: 700;
  }

  .fc-button-group button, .fc-today-button,
  .fc-button-primary:not(:disabled):active, .fc-button-primary:not(:disabled).fc-button-active {
    background-color: #eee !important;
    border: none !important;
    color: #333 !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-radius: 2px !important;
    padding: 5px 15px;
  }

</style>


// WEBPACK FOOTER //
// src/views/calendar.vue